import React from 'react';
import { Switch, Route, Redirect } from 'react-router';

import AuthOrApp from './authOrApp'
import Dashboard from '../dashboard/dashboard';
import UsuarioPerfil from '../usuarioPerfil/usuarioPerfil';
import Usuario from '../usuario/usuario';
import GrupoProduto from '../grupoProduto/grupoProduto';
import Produto from '../produto/produto';
import Cliente from '../cliente/cliente';
import Pedido from '../pedido/pedido';
import PedidoHistorico from '../pedido/pedidoHistorico';

export default props => (
	<div id='id-content-wrapper' className='content-wrapper' style={{ paddingBottom: 0 }} >
		<Switch>
			<Route exact path='/' component={Pedido} />
			<Route path='/usuarioPerfil' component={UsuarioPerfil} />
			<Route path='/usuario' component={Usuario} />
			<Route path='/grupoProduto' component={GrupoProduto} />
			<Route path='/produto' component={Produto} />
			<Route path='/cliente' component={Cliente} />
			<Route path='/pedido' component={Pedido} />
			<Route path='/pedidoHistorico' component={PedidoHistorico} />
			<Redirect from='*' to='/' />
		</Switch>
	</div>
);
